'use client'
import { useLanguage } from '@/lib/context/LanguageContext'
import { BlurIn } from '@/components/ui/FadeInUp'
import { pillars } from '@/lib/data/manifesto'
import { PillarCard } from './manifesto/PillarCard'

export default function Manifesto() {
  const { lang, t, isRTL } = useLanguage()
  const m = t.manifesto

  return (
    <section
      id="manifesto"
      data-nav-dark
      className="py-8 sm:py-10 md:py-12 border-b border-white/5"
      style={{ background: '#0b1629' }}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <BlurIn>
          <h2 className="text-[13px] font-bold uppercase tracking-[0.28em] mb-5 md:mb-6 text-white">
            {m.eyebrow}
          </h2>
        </BlurIn>

        {/* Three zigzag pillar rows — cards alternate side, each paired
            with copy that animates in concert on hover. Sized so eyebrow
            + 3 rows fit a single ~900px viewport (no CTA below). */}
        <div className="flex flex-col gap-4 md:gap-5">
          {pillars.map((pillar, i) => (
            <PillarCard
              key={pillar.iconKey}
              pillar={pillar}
              cardSide={i % 2 === 0 ? 'right' : 'left'}
              lang={lang}
              isRTL={isRTL}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
